/**
 * Used by {@link timeout} to indicate timeouts.
 */
export class TimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';
  }
}

/**
 * Takes a Promise, and wraps it in a Promise that times out after the specified
 * number of milliseconds. If the timeout is reached before the input Promise
 * resolves, then this Promise throws an exception.
 *
 * Takes an optional `errorMessage` argument if a custom error message is desired.
 */
export default function timeout<T>(
  ms: number,
  p: Promise<T>,
  errorMessage?: string,
): Promise<T> {
  return Promise.race([
    p,
    new Promise((_resolve, reject) => {
      setTimeout(() => reject(new TimeoutError(errorMessage || 'timeout error')), ms);
    }) as Promise<T>,
  ]);
}
